import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  textField: {
    width: '100%'
  },
  titleTextField: {
    width: '100%',
    '&& .no-format:focus': {
      border: `0px solid ${capitalDesignTokens.semanticColors.interaction.focus}`,
      padding: '4px 10px'
    },
    '&& .no-format:hover': {
      border: 'none'
    }
  },
  infoText: {
    maxWidth: '580px',
    marginTop: '-8px',
    color: capitalDesignTokens.foundations.colors.gray700
  },
  customReportsLink: {
    color: capitalDesignTokens.semanticColors.interaction.focus,
    textDecoration: 'underline',
    cursor: 'pointer'
  }
});
